import { Pipe, PipeTransform } from '@angular/core';
import { TherapyPlanStatusEnum } from '@therapist/shared/models/therapy-plan/therapy-plan-status.enum';

@Pipe({ name: 'therapyPlanStatusTranslations' })
export class TherapyPlanStatusTranslationsPipe implements PipeTransform {

  transform(value: TherapyPlanStatusEnum, ...args: unknown[]): string {
    switch (value) {
      case TherapyPlanStatusEnum.Started:
        return 'Gestartet';

      case TherapyPlanStatusEnum.Planned:
        return 'Geplant';

      case TherapyPlanStatusEnum.Canceled:
        return 'Abgebrochen';

      case TherapyPlanStatusEnum.Finished:
        return 'Abgeschlossen';

      default:
        return '';
    }
  }
}
